export default __webpack_public_path__ + "static/media/Leadership_01_header.98e6de71.png";